module.exports = __webpack_public_path__ + "4d01f4d617b31034796186e2ec14cfab.svg";